import { Edit } from "@mui/icons-material";
import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";

import Colors from "../../../../../components/global/Colors";
import Navigation from "../../../../../components/navigations/finance/cases/detail/navigation";
import BasicButton from "../../../../../components/ui library/components/buttons/BasicButton";
import CustomDataGrid from "../../../../../components/ui library/components/data-grid/CustomDataGrid";
import Pagination from "../../../../../components/ui library/components/data-grid/Pagination";
import { sortNumbers, sortStrings } from "../../../../../components/ui library/helpers/functions";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { useQueryParams } from "../../../../../hooks/useQueryParams";

import AddExpense from "./components/AddExpense";
import DeleteExpense from "./components/DeleteExpense";

export default () => {
  const { additionalExpenses, additionalExpenseOptions, additionalExpenseCount } = useLoaderData();
  const { filters, updateFilter } = useQueryParams();
  const { _case } = useParentLoaderData();
  const [selectedRows, setSelectedRows] = useState([]);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [expenseToEdit, setExpenseToEdit] = useState(null);
  const [expenseToDelete, setExpenseToDelete] = useState(null);

  const columns = [
    {
      ...GRID_CHECKBOX_SELECTION_COL_DEF,
      renderHeader: () => <></>,
    },
    {
      field: "label",
      headerName: "Label",
      flex: 2,
      align: "center",
      headerAlign: "center",
      sortable: false,
      filterable: false,
      sortComparator: sortStrings,
    },
    {
      field: "amount",
      headerName: "Amount",
      flex: 1,
      valueFormatter: (value) => `$${value}`,
      align: "right",
      headerAlign: "right",
      sortable: false,
      filterable: false,
      sortComparator: sortNumbers,
    },
    {
      field: "deductionType",
      headerName: "Deducted From",
      flex: 2,
      align: "center",
      headerAlign: "center",
      valueFormatter: getDeductionTypeName,
      sortable: false,
      filterable: false,
      sortComparator: (val1, val2) =>
        sortStrings(getDeductionTypeName(val1), getDeductionTypeName(val2)),
    },
    {
      field: "actions",
      headerName: "",
      align: "right",
      flex: 0.5,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return <Edit onClick={() => openEditExpense(params.row)} />;
      },
    },
  ];

  function getDeductionTypeName(value) {
    return (
      additionalExpenseOptions.deductionTypeOptions.find((opt) => opt.value === value)
        ?.display_name ?? ""
    );
  }

  const openEditExpense = (expense) => {
    setAddModalOpen(true);
    setExpenseToEdit(expense);
  };

  const openDeleteExpense = () => {
    const expense = additionalExpenses.find((expense) => expense.id === selectedRows[0]);
    setExpenseToDelete(expense);
    setDeleteModalOpen(true);
  };

  useEffect(() => {
    updateFilter("limit", filters.get("limit") || 25);
  }, []);

  return (
    <Navigation activeTab="expenses" _case={_case}>
      <div className="p-4">
        <div className="mb-1 flex items-center justify-end">
          {selectedRows.length > 0 && (
            <BasicButton
              className="mr-4"
              color="error"
              disabled={selectedRows.length === 0}
              onClick={openDeleteExpense}
              text="Delete"
              sx={{
                backgroundColor: Colors.red[500],
              }}
            />
          )}
          <BasicButton
            onClick={() => setAddModalOpen(true)}
            text="Add Expense"
            variant="outlined"
          />
        </div>
        <div className="h-[calc(100vh-18rem)] w-full overflow-y-auto">
          <CustomDataGrid
            columns={columns}
            checkboxSelection
            disableRowSelectionOnClick
            disableMultipleRowSelection
            rowSelection
            rows={additionalExpenses || []}
            onRowSelectionModelChange={(val) => setSelectedRows(val)}
          />
        </div>
        <Pagination
          filters={filters}
          updateFilter={updateFilter}
          totalCount={additionalExpenseCount}
        />
        <AddExpense
          activeExpense={expenseToEdit}
          deductionOpts={additionalExpenseOptions.deductionTypeOptions}
          open={addModalOpen}
          setActiveExpense={setExpenseToEdit}
          setOpen={setAddModalOpen}
        />
        <DeleteExpense
          activeExpense={expenseToDelete}
          deductionOpts={additionalExpenseOptions.deductionTypeOptions}
          open={deleteModalOpen}
          setActiveExpense={setExpenseToDelete}
          setOpen={setDeleteModalOpen}
        />
      </div>
    </Navigation>
  );
};
